import React, { Component } from "react"
import NewLayout from "../layout/newLayout"
import styles from "../styles/scss/pages/contactUs.module.scss"
import SEO from "../components/seo"
import { Formik } from "formik"
import { signUp } from "../services/email"
import { getOccupations } from "../services/util"
import PageContents from "../components/pageContents"
import {
    TextInput,
    Select,
    Checkbox,
    ErrorSummary,
    FormStatus,
    SubmitButton,
    RequiredNote,
    bind,
    fieldError,
    summaryErrors,
    isValidEmail,
    phoneError,
    formStyles as f,
} from "../components/form"


export default class Index extends Component {
    attached = this.props.pageContext.page.attachments.filter(att => {
        return att.slug === "thank-you"
    })

    state = {
        pg: this.props.pageContext.page,
        thankyou: this.attached.length > 0 ? this.attached[0] : null,
        submitted: false,
        submitError: false,
    }

    occupations = getOccupations()

    render() {
        const { submitted, submitError, pg, thankyou } = this.state
        return (
            <NewLayout>
                {pg.seo.title && (
                    <h1 style={{ display: "none" }}>{pg.seo.title}</h1>
                )}
                <SEO page={pg} />
                <div className="d-flex flex-column flex-fill">
                    <div className={styles.container}>
                        {submitted ? (
                            <PageContents content={thankyou.content} />
                        ) : (
                            <>
                                <PageContents content={pg.content} />
                                <Formik
                                    initialValues={{
                                        firstName: "",
                                        lastName: "",
                                        email: "",
                                        phone: "",
                                        occupation__pc: "",
                                        agreeToPromotionalMessages: false,
                                    }}
                                    validate={values => {
                                        let errors = []
                                        if (!values.firstName) {
                                            errors.push({ field: "firstName", message: "First Name is required" })
                                        }
                                        if (!values.lastName) {
                                            errors.push({ field: "lastName", message: "Last Name is required" })
                                        }
                                        if (!values.email) {
                                            errors.push({ field: "email", message: "Email is required" })
                                        } else if (!isValidEmail(values.email)) {
                                            errors.push({ field: "email", message: "Invalid email address" })
                                        }
                                        // Required for SMS; otherwise optional, but complete if filled
                                        const phoneMsg = phoneError(values.phone, {
                                            required: values.agreeToPromotionalMessages,
                                            requiredMessage: "Phone Number is required to opt in for SMS messages",
                                        })
                                        if (phoneMsg) errors.push({ field: "phone", message: phoneMsg })
                                        if (values.occupation__pc === "") {
                                            errors.push({ field: "occupation__pc", message: "Occupation is required" })
                                        }
                                        return errors
                                    }}
                                    onSubmit={(values, { setSubmitting }) => {
                                        this.setState({ submitError: false })

                                        const data = {
                                            firstName: values.firstName,
                                            lastName: values.lastName,
                                            email: values.email,
                                            phone: values.phone,
                                            occupation__pc: values.occupation__pc,
                                            industry: "",
                                            industrytime: "",
                                            birthday: "",
                                            userplus18yearsold: true,
                                            confirmation: true,
                                            optSubject: "",
                                            optMessage: "",
                                            signupFormID: 1828532,
                                            formIdentifier: "signup",
                                            agreeToPromotionalMessages: values.agreeToPromotionalMessages,
                                        }

                                        signUp(data)
                                            .then(result => {
                                                setSubmitting(false)
                                                const redirect = (result && result.data && result.data.redirect) || (result && result.redirect)
                                                if (redirect) {
                                                    try {
                                                        const url = new URL(redirect, window.location.origin)
                                                        window.location.assign(url.toString())
                                                    } catch (e) {
                                                        window.location.assign(redirect)
                                                    }
                                                } else {
                                                    this.setState({ submitted: true })
                                                }
                                            })
                                            .catch(err => {
                                                setSubmitting(false)
                                                this.setState({ submitError: true })
                                                console.log(err)
                                            })
                                    }}
                                >
                                    {props => (
                                        <form className={f.form} onSubmit={props.handleSubmit} noValidate>
                                            <RequiredNote />
                                            <ErrorSummary errors={summaryErrors(props)} submitCount={props.submitCount} />
                                            <FormStatus status={submitError ? "error" : null} />
                                            <div className={f.row}>
                                                <TextInput label="First Name" required autoComplete="given-name" placeholder="John" {...bind(props, "firstName")} />
                                                <TextInput label="Last Name" required autoComplete="family-name" placeholder="Doe" {...bind(props, "lastName")} />
                                            </div>
                                            <div className={f.row}>
                                                <TextInput label="Email" type="email" required autoComplete="email" placeholder="jdoe@email.com" {...bind(props, "email")} />
                                                <TextInput
                                                    label="Phone Number"
                                                    type="tel"
                                                    mask="phone"
                                                    autoComplete="tel-national"
                                                    placeholder="(000) 000-0000"
                                                    required={props.values.agreeToPromotionalMessages}
                                                    help={props.values.agreeToPromotionalMessages ? "Required to receive SMS messages" : undefined}
                                                    {...bind(props, "phone")}
                                                />
                                            </div>
                                            <Checkbox
                                                name="agreeToPromotionalMessages"
                                                consent
                                                className={f.field}
                                                checked={props.values.agreeToPromotionalMessages}
                                                onChange={e => props.setFieldValue("agreeToPromotionalMessages", e.target.checked)}
                                                error={fieldError(props, "agreeToPromotionalMessages")}
                                                label={
                                                    <>
                                                        By checking this box I agree to receive promotional messages from WD-40 Company.
                                                        Message frequency varies. Text HELP to 65254 for help, Text STOP to 65254 to end.
                                                        Message and Data Rates May Apply. By opting in, I authorize WD-40 Company to deliver
                                                        SMS messages using an automatic telephone dialing system and I understand that I am
                                                        not required to opt in as a condition of purchasing any goods or services. By leaving
                                                        this box unchecked you will not be opted in for SMS messages at this time. Click to
                                                        view our <a href="/terms-of-use">Terms &amp; Conditions</a> or our{" "}
                                                        <a href="/privacy/">Privacy Policy</a>
                                                    </>
                                                }
                                            />
                                            <div className={f.row}>
                                                <Select
                                                    label="Occupation"
                                                    required
                                                    options={this.occupations}
                                                    {...bind(props, "occupation__pc")}
                                                />
                                            </div>
                                            <div className={f.actions}>
                                                <SubmitButton busy={props.isSubmitting}>Submit</SubmitButton>
                                            </div>
                                        </form>
                                    )}
                                </Formik>
                            </>
                        )}
                    </div>
                </div>
            </NewLayout>
        )
    }
}
